import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import PanelLayout from "layouts/PanelLayout";
import "styles/teacher.css";
import { TbSmartHome } from "react-icons/tb";
import { GoPlus } from "react-icons/go";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { toast } from "react-toastify";

const API_BASE = "https://algoritm-api-edu.uz";

const TestsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Har safar location.state dan yangi subject olish
  const passedSubject = location.state?.subject;

  const [subject, setSubject] = useState(null);
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);

  // Testlarni yuklash funksiyasi
  const fetchTests = async (subjectSlug) => {
    if (!subjectSlug) {
      setTests([]);
      setLoading(false);
      return;
    }

    const token = localStorage.getItem("accessToken");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/teacher/Test/GetAll`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subjectSlug,
          page: 1,
          pageSize: 100,
        }),
      });

      if (!res.ok) {
        const errText = await res.text();
        throw new Error(errText || "Testlar yuklanmadi");
      }

      const data = await res.json();
      const testList = data.rows || data.data || data || [];

      setTests(
        testList.map((t) => ({
          slug: t.slug,
          title: t.title || "Nomsiz test",
          description: t.description || "",
          type: t.type || "Standart",
          status: t.status || "Created",
          attemptCount: t.attemptCount || t.allowedAttempts,
          allowedMinutes: t.allowedMinutes || t.time,
        }))
      );
    } catch (err) {
      console.error("Test yuklash xatosi:", err);
      toast.error("Testlar yuklanmadi!");
      setTests([]);
    } finally {
      setLoading(false);
    }
  };

  // location.state o'zgarganda subject ni majburiy yangilash
  useEffect(() => {
    if (passedSubject && passedSubject.slug) {
      // Agar yangi subject eski bilan farq qilsa – majburiy yangilash
      setSubject((prev) => {
        if (!prev || prev.slug !== passedSubject.slug) {
          return passedSubject;
        }
        return prev;
      });
    } else {
      // Agar state yo'q bo'lsa – foydalanuvchini fan tanlashga qaytarish
      toast.warn("Fan tanlanmagan!");
      navigate("/teacher");
    }
  }, [passedSubject, navigate]);

  // subject o'zgarganda testlarni qayta yuklash
  useEffect(() => {
    if (subject?.slug) {
      fetchTests(subject.slug);
    }
  }, [subject]);

  // Menyu tashqarisida bosilganda yopish
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".menu-icon") && !e.target.closest(".dropdown-menu")) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleConfirm = async (testSlug) => {
    const token = localStorage.getItem("accessToken");
    try {
      const res = await fetch(`${API_BASE}/api/teacher/Test/Confirm/${testSlug}`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        toast.success("Test tasdiqlandi!");
        fetchTests(subject.slug);
      } else {
        toast.error("Tasdiqlashda xato");
      }
    } catch {
      toast.error("Internet aloqasi yo‘q");
    }
    setActiveMenu(null);
  };

  const handleCancel = async (testSlug) => {
    if (!window.confirm("Test bekor qilinsinmi?")) return;
    const token = localStorage.getItem("accessToken");
    try {
      const res = await fetch(`${API_BASE}/api/teacher/Test/Cancel/${testSlug}`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        toast.success("Test bekor qilindi");
        fetchTests(subject.slug);
      } else {
        toast.error("Bekor qilishda xato");
      }
    } catch {
      toast.error("Xato yuz berdi");
    }
    setActiveMenu(null);
  };

  const handleDelete = async (testSlug) => {
    if (!window.confirm("Test butunlay o‘chirilsinmi?")) return;
    const token = localStorage.getItem("accessToken");
    try {
      const res = await fetch(`${API_BASE}/api/teacher/Test/Delete/${testSlug}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        toast.success("Test o‘chirildi");
        fetchTests(subject.slug);
      } else {
        toast.error("O‘chirishda xato");
      }
    } catch {
      toast.error("Xato yuz berdi");
    }
    setActiveMenu(null);
  };

  if (!subject) {
    return (
      <div>
        <div style={{ textAlign: "center", padding: "150px" }}>
          <p>Fan yuklanmoqda...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="subject-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span onClick={() => navigate("/teacher")}>
              <TbSmartHome style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }} />
            </span>
            <span className="divider">/</span>
            <span
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer", color: "#01CC0D" }}
            >
              {subject.fullName || subject.fullname || "Fan nomi"}
            </span>
            <span className="divider">/</span>
            <span className="current">Testlar</span>
          </div>

          <button
            className="add-btn"
            onClick={() => navigate("/teacher/add-test", { state: { subject } })}
          >
            <GoPlus style={{ fontSize: 20 }} /> Test yaratish
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "100px" }}>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              Yuklanmoqda...
            </motion.p>
          </div>
        ) : tests.length === 0 ? (
          <div style={{ textAlign: "center", padding: "100px", color: "#94a3b8" }}>
            <h3>Hozircha testlar yo‘q</h3>
            <p>"Test yaratish" tugmasi orqali birinchi testni yarating</p>
          </div>
        ) : (
          <div className="test-grid">
            {tests.map((t) => (
              <motion.div
                key={t.slug}
                className="test-box"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <div className="test-top">
                  <div className="badge-group">
                    <span className={`badge ${t.type?.toLowerCase() || "standart"}`}>
                      {t.type || "Standart"}
                    </span>
                    {t.status === "Created" && <span className="new-tag">Yangi</span>}
                  </div>

                  <div className="menu-icon" onClick={() => setActiveMenu(activeMenu === t.slug ? null : t.slug)}>
                    <HiOutlineDotsVertical size={20} />
                  </div>

                  {activeMenu === t.slug && (
                    <div className="dropdown-menu">
                      <p
                        onClick={() =>
                          navigate(`/teacher/test/${t.slug}`, {
                            state: { test: t, subject },
                          })
                        }
                      >
                        Ko‘rish
                      </p>
                      <p
                        onClick={() =>
                          navigate("/teacher/add-test", {
                            state: { test: t, subject, isEdit: true },
                          })
                        }
                      >
                        Tahrirlash
                      </p>

                      {t.status === "Created" && (
                        <p onClick={() => handleConfirm(t.slug)}>Tasdiqlash</p>
                      )}

                      {t.status === "Confirmed" && (
                        <p onClick={() => handleCancel(t.slug)}>Bekor qilish</p>
                      )}

                      <p onClick={() => handleDelete(t.slug)}>O‘chirish</p>

                      <p
                        onClick={() =>
                          navigate("/teacher/add-questions", {
                            state: { test: t, subject },
                          })
                        }
                      >
                        Savollar qo'shish
                      </p>
                    </div>
                  )}
                </div>

                <h4>{t.title}</h4>
                <p>{t.description || "Izoh yo‘q."}</p>

                {t.status === "Created" && (
                  <button className="test-confirm-btn" onClick={() => handleConfirm(t.slug)}>
                    Tasdiqlash
                  </button>
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestsPage;